import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const AddTodo = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 5.5C3 4.67157 3.67157 4 4.5 4H6.5C6.77614 4 7 3.77614 7 3.5C7 3.22386 6.77614 3 6.5 3H4.5C3.11929 3 2 4.11929 2 5.5V11.5C2 12.8807 3.11929 14 4.5 14H10.5C11.8807 14 13 12.8807 13 11.5V9.5C13 9.22386 12.7761 9 12.5 9C12.2239 9 12 9.22386 12 9.5V11.5C12 12.3284 11.3284 13 10.5 13H4.5C3.67157 13 3 12.3284 3 11.5V5.5ZM10.4289 6.69696C10.6014 6.48133 10.5664 6.16668 10.3508 5.99418C10.1352 5.82167 9.82054 5.85664 9.64803 6.07227L6.61239 9.86682L5.3151 8.56952C5.11983 8.37426 4.80325 8.37426 4.60799 8.56952C4.41273 8.76478 4.41273 9.08137 4.60799 9.27663L6.3003 10.9689C6.40086 11.0695 6.5395 11.1225 6.6815 11.1146C6.8235 11.1068 6.95544 11.0388 7.04428 10.9277L10.4289 6.69696Z"
        fill={color}
      />
      <path d="M12.5 0.5V6.5M9.5 3.5H15.5" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
})

export default AddTodo
